/**********************************
 * Navigation Constants
 **********************************/

export const NAVIGATION = {
  DRAWER_NAME: {},
  SCRIPT_NAME: {
    START_SUPPORT_CHAT: 'Start Support Chat',
  },
  SCREEN_NAME: {
    KNOWLEDGE_BASE: 'Knowledge Base',
    TRAINING_WEBINARS: 'Training Webinars',
    REAPIT_SALES_ACADEMY: 'Reapit Sales Academy',
    MANAGE_MFA: 'Manage MFA',
    TERMS_AND_CONDITIONS: 'Terms and Conditions',
    LOGOUT: 'Logout',
  },
  MODAL_NAME: {
    SYSTEM_ID: 'System ID',
    SUBMIT_SUPPORT_REQUEST: 'Submit Support Request',
    SUBMIT_SYSTEM_CHANGE: 'Submit System Change',
    UNIVERSAL_SEARCH: 'Universal Search',
  },
  PANEL_NAME: {
    // Quick Add
    QUICK_ADD_CONTACT: 'Quick Add Contact',
    QUICK_ADD_NOTE: 'Quick Add Note',
    QUICK_ADD_PROSPECT_APPRAISAL: 'Quick Add Prospect / Appraisal',
    QUICK_ADD_LOG_ENQUIRY: 'Quick Add Log Enquiry',
    QUICK_ADD_TASK: 'Quick Add Task',
    QUICK_ADD_APPOINTMENT: 'Quick Add Appointment',
    QUICK_ADD_APPLY_SCHEDULE: 'Quick Add Apply Schedule',
    QUICK_ADD_NEW_REFERRAL: 'Quick Add New Referral',
    // User Menu
    MY_PROFILE: 'My Profile',
    MANAGE_SUBSCRIPTION: 'Manage Subscription',
    MANAGE_SMS_CREDITS: 'Manage SMS Credits',
    PORTAL_LOGS: 'Portal Logs',
    PURCHASE_SMS_CREDITS: 'Purchase SMS Credits',
    E_NEWSLETTER_SCHEDULE: 'E-Newsletter Schedule',
    TESTMONIALS: 'Testimonials',
  },
  MENU_NAME: {
    USER_MENU: 'User Menu',
    HELP_MENU: 'Help Menu',
    QUICK_ADD: 'Quick Add',
  },
  ACTION: {
    // Main Navigation
    NAVIGATE_DASHBOARD: 'Navigate_Route_Dashboard',
    NAVIGATE_PROPERTIES: 'Navigate_Route_Properties',
    NAVIGATE_CONTACTS: 'Navigate_Route_Contacts',
    NAVIGATE_LEADS: 'Navigate_Route_Leads',
    NAVIGATE_REPORTS: 'Navigate_Route_Reports',
    NAVIGATE_PROSPECTOR: 'Navigate_Route_Prospector',
    NAVIGATE_TRUST: 'Navigate_Route_Trust',
    // Secondary Menu
    NAVIGATE_TASKS: 'Navigate_Route_Tasks',
    NAVIGATE_MY_OFFICE: 'Navigate_Route_My_Office',
    // Help Menu
    OPEN_HELP_MENU: 'Open_Help_Menu',
    NAVIGATE_START_SUPPORT_CHAT: 'Start_Support_Chat',
    NAVIGATE_SUBMIT_SUPPORT_REQUEST: 'Open_Submit_Support_Request',
    NAVIGATE_SUBMIT_SYSTEM_CHANGE: 'Open_Submit_System_Change',
    NAVIGATE_KNOWLEDGE_BASE: 'Knowledge_Base',
    NAVIGATE_TRAINING_WEBINARS: 'Training_Webinars',
    NAVIGATE_REAPIT_SALES_ACADEMY: 'Reapit_Sales_Academy',
    NAVIGATE_SYSTEM_ID: 'System_ID',
    NAVIGATE_UNIVERSAL_SEARCH: 'Open_Universal_Search',
    // Quick Add
    OPEN_QUICK_ADD: 'Open_Quick_Add',
    NAVIGATE_QUICK_ADD_CONTACT: 'Open_Panel_Quick_Add_Contact',
    NAVIGATE_QUICK_ADD_NOTE: 'Open_Panel_Quick_Add_Note',
    NAVIGATE_QUICK_ADD_PROSPECT_APPRAISAL: 'Open_Panel_Quick_Add_Prospect_Appraisal',
    NAVIGATE_QUICK_ADD_LOG_ENQUIRY: 'Open_Panel_Quick_Add_Log_Enquiry',
    NAVIGATE_QUICK_ADD_TASK: 'Open_Panel_Quick_Add_Task',
    NAVIGATE_QUICK_ADD_APPOINTMENT: 'Open_Panel_Quick_Add_Appointment',
    NAVIGATE_QUICK_ADD_APPLY_SCHEDULE: 'Open_Panel_Quick_Add_Apply_Schedule',
    NAVIGATE_QUICK_ADD_NEW_REFERRAL: 'Open_Panel_Quick_Add_New_Referral',
    // User Menu
    OPEN_USER_MENU: 'Open_User_Menu',
    NAVIGATE_MY_PROFILE: 'Open_Panel_My_Profile',
    NAVIGATE_MANAGE_SUBSCRIPTION: 'Open_Panel_Manage_Subscription',
    NAVIGATE_MANAGE_SMS_CREDITS: 'Open_Panel_Manage_SMS_Credits',
    NAVIGATE_PURCHASE_SMS_CREDITS: 'Open_Panel_Purchase_SMS_Credits',
    NAVIGATE_PORTAL_LOGS: 'Open_Panel_Portal_Logs',
    NAVIGATE_MANAGE_MFA: 'Open_Manage_MFA',
    NAVIGATE_E_NEWSLETTER_SCHEDULE: 'Open_Panel_E_Newsletter_Schedule',
    NAVIGATE_TERMS_AND_CONDITIONS: 'Open_Panel_Terms_and_Conditions',
    NAVIGATE_TESTIMONIALS: 'Open_Panel_Testimonials',
    NAVIGATE_CMS_EDITOR: 'Navigate_CMS_Editor',
    NAVIGATE_LOGOUT: 'Logout',
  },
}
